module.exports = __webpack_public_path__ + "img/page39.443df4c5.gif";